<template>
  <div>
    <div class='header'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-3 logo'>
                    <img src='/static/image/logo.png'>
                </div>
                <div class='col-md-6 nav'>
                    <div class='nav-item' v-for='(item, key) in navs' 
                        :class='key == navActive ? "active" : ""'>
                        <a :href='"#"+item.href'>{{item.name}}</a>
                    </div>
                </div>
                <div class='col-md-3 user'>
                    <div class='logout' v-if='!user'>
                        <a class='yi-btn xs orange-o' href='/#/login'>登录</a>
                        <a class='yi-btn xs orange-o' href='/#/register'>注册</a>
                    </div>
                    <div class='login' v-if='user'>
                        <span>欢迎：<a href='/#/user'>{{user.username}}</a></span>
                        <button class='yi-btn xs orange-o' @click='logout()'>登出</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <router-view :user='user' :logout='logout' :setUser='setUser' 
        :updateUser='updateUser'></router-view>
    <div class='footer'>
        <div class='container'>
            <div class='box-link row'>
                <div class='col-md-2 col-md-offset-2'>
                    <a href='/#/about/protocol'>服务协议</a>
                </div>
                <div class='col-md-2'>
                    <a href='/#/about/privacy'>隐私保护</a>
                </div>
                <div class='col-md-2'>
                    <a href='/#/about/protect'>家长监护</a>
                </div>
                <div class='col-md-2'>
                    <a href='/#/about/law'>法律声明</a>
                </div>
            </div>

            <div class='box-text row'>
                <div class='col-md-2 logo'>
                    <img src='/static/image/logo-white.png'>
                </div>
                <div class='col-md-7 text'>
                    <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。</p>
                    <p>公司地址：重庆市江北区嘉陵一村41号3幢21-5</p>
                    <p>统一社会信用代码：91500105MA5URQ0284</p>
                    <p>网站备案/许可证号 : <a href="https://beian.miit.gov.cn" target="_blank">渝ICP备17012945号</a></p>
                    <p>网络文化经营：渝网文<a href="/static/image/beian.jpg" target="_blank">[2018]0712-010号</a>
                        <!--<a href="/static/image/beian.jpg" target="_blank">渝公网安备 50010502001410号</a>-->
                    </p>
                    <p>增值电信业务经营许可证号：渝B2-20180078</p>
                    <p>COPYRIGHT@Since 2017 重庆应答网络科技有限公司 版权所有</p>
                    <div class='img'>
                        <a href="http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/146542ffb80f4e67a5b8b8774688ebb1" target="_blank">
                            <img src='/static/image/f.png'>
                        </a>
                        <img src='/static/image/f02.png'>
                        <img src='/static/image/f03.png'>
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010502001639" target="_blank">
                            <img src="/static/image/beianIcon.png" alt="">渝公网安备 50010502001639号
                        </a>
                    </div>
                </div>
                <div class='col-md-3 qr-code'>
                    <div class='row'>
                        <div class='col-md-6'>
                            <img src='/static/image/qrcode.png'>
                            <div class='name'>官方微博</div>
                        </div>
                        <div class='col-md-6'>
                            <img src='/static/image/qrcode.png'>
                            <div class='name'>官方微信号</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>


<script>
import Notify from '@/common/Notify'
import Storage from '@/common/Storage'
import Request from '@/common/Request'
import Common from '@/common/Common'
export default {
    name: 'App',
    data : function(){
        return {
            'navs' : [
                {
                    'name' : '首页',
                    'href' : '/',
                },{
                    'name' : '通行证',
                    'href' : '/user',
                },{
                    'name' : '充值中心',
                    'href' : '/recharge',
                },{
                    'name' : '客服中心',
                    'href' : '/service',
                },{
                    'name' : '人才招聘',
                    'href' : '/job',
                },{
                    'name' : '关于应答',
                    'href' : '/about',
                },
            ],
            'navActive' : 0,
            'user' : false
        }
    },
    methods : {
        //退出登录
        logout : function(){
            this.user = false
            Storage.remove('user')
            Common.toUrl('/login')
            return true
        },

        //设置用户
        setUser : function(user){
            Storage.set('user', user)
            this.user = user
        },
        
        //更新用户信息
        updateUser : function(){
            var url = Request.createApi('/app/user/detail')
            Request.get(url, res => {
                this.user = res.info
            })
        },

        toUrl : function(url){
            Common.toUrl(url)
        },
    },
    created : function(){
        Request.getLoginUser(user => {
            this.setUser(user)
        })

        this.user = Storage.get('user')

        //路由确认
        for(var k in this.navs){
            var nav = this.navs[k]
            if(this.$route.path == nav.href){
                this.navActive = k
                break
            }
        }
    },
    mounted : function(){
        if ('-ms-scroll-limit' in document.documentElement.style 
            && '-ms-ime-align' in document.documentElement.style) {
            window.addEventListener('hashchange', () => {
                var currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        }
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = 'https://wp.qiye.qq.com/qidian/2852159797/e4e4727fa335462b9782eb0b9c51e328';
        document.body.appendChild(s);
    },
    watch : {
        '$route': function(route) {
            var uri = route.path
            if(uri.indexOf('/user') === 0 
                || uri.indexOf('/login') === 0 
                || uri.indexOf('/register') === 0
            ){
                this.navActive = 1
            }else if(uri.indexOf('/recharge') === 0){
                this.navActive = 2
            }else if(uri.indexOf('/service') === 0){
                this.navActive = 3
            }else if(uri.indexOf('/job') === 0){
                this.navActive = 4
            }else if(uri.indexOf('/about') === 0){
                this.navActive = 5
            }else{
                this.navActive = 0
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue